const getters = {
  date: state => state.app.date,
  isAndroid: state => state.app.isAndroid,
  selectVal: state => state.app.selectVal
}
export default getters
